module.exports = __webpack_public_path__ + "static/scb-b32c65ef081e81677040a92ff139c26a.png";